import { Input } from 'antd';
import React from 'react';

interface FormInputProps {
    value: string | null;
    onChange: (value: string) => void;
    placeholder?: string;
    style?: React.CSSProperties;
}

const FormInput: React.FC<FormInputProps> = React.forwardRef<any, FormInputProps>(
    ({ value, onChange, placeholder = '', style, ...restProps }, _ref) => {
        return (
            <Input
                placeholder={placeholder}
                value={value || ''}
                onChange={(e) => onChange(e.target.value)}
                style={style}
                {...restProps}
            />
        );
    },
);

export default React.memo(FormInput);
